export const configurations = {
  MurabahaRate: 2.75,
  MinPayment: 100, 
  MinPaymentPer: 5,

  NetSalaryBoundaries:{
    min:100,
    max:1000000,
  }
};
